import {FeatureKey, Key} from '@dms/api/shared';

import {Nullish} from 'shared/web';

export function buildTree(items: Key[] | Nullish, search: string | Nullish) {
  if (!items) {
    return {
      features: [],
      treeOwnerMap: new Map<string, string>(),
    };
  }

  const itemsMap = new Map<string, FeatureKey>();
  const treeOwnerMap = new Map<string, string>();

  items.forEach((item) => {
    itemsMap.set(item.const_key, {...item, children: [], level: 0});
  });

  const rootItems: FeatureKey[] = [];

  // Helper function to recursively find the topmost parent
  const findTopMostParent = (key: string, visited = new Set<string>()): string => {
    if (visited.has(key)) {
      // Cycle detected, return the key to prevent infinite recursion
      return key;
    }
    visited.add(key);

    const item = itemsMap.get(key);
    if (!item || !item.parent) {
      return key; // This is a root item
    }
    return findTopMostParent(item.parent, visited);
  };

  items.forEach((item) => {
    const currentItem = itemsMap.get(item.const_key)!;

    if (item.parent) {
      const parent = itemsMap.get(item.parent);

      if (parent) {
        parent.children.push(currentItem);
        currentItem.level = parent.level + 1;

        // Always find the topmost parent recursively
        const topMostParent = findTopMostParent(item.const_key);
        treeOwnerMap.set(item.const_key, topMostParent);
      }

      return;
    }

    rootItems.push(currentItem);
    treeOwnerMap.set(item.const_key, item.const_key);
  });

  const filterTree = (treeNode: FeatureKey) => {
    if (
      treeNode.labels.some((item) =>
        item.label.toLowerCase().includes((search || '').toLowerCase())
      )
    ) {
      return true;
    }

    treeNode.children = treeNode.children.filter(filterTree);

    return treeNode.children.length > 0;
  };

  return {
    features: search ? rootItems.filter(filterTree) : rootItems,
    treeOwnerMap,
  };
}
